import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    delay: { type: Number, default: 0 },
    direction: { type: String, default: "up" }
  }

  connect() {
    // Set initial state
    this.element.style.opacity = "0"
    this.element.style.transition = "opacity 0.8s ease-out, transform 0.8s ease-out"

    // Set initial transform based on direction
    const offset = "20px"
    switch (this.directionValue) {
      case "up":
        this.element.style.transform = `translateY(${offset})`
        break
      case "down":
        this.element.style.transform = `translateY(-${offset})`
        break
      case "left":
        this.element.style.transform = `translateX(${offset})`
        break
      case "right":
        this.element.style.transform = `translateX(-${offset})`
        break
    }

    // Animate after delay
    setTimeout(() => {
      this.element.style.opacity = "1"
      this.element.style.transform = "translate(0, 0)"
    }, this.delayValue)
  }
}
